'use client'

// Hero CTA pair for the city SEO pages. Primary = the grass-ID app funnel
// (/diagnose); secondary = the city's pre-filled fertilizer schedule. Both fire a
// PostHog event so hero conversion is measurable. Rendered inside the server
// component's hero; it SSRs to crawlable HTML.

import Link from 'next/link'
import { Camera, CalendarCheck, ArrowRight } from 'lucide-react'
import { cityDiagnoseHref, cityFertilizerHref } from '@/lib/city-seo/tool-links'
import { trackEvent } from '@/lib/analytics'

export interface CityHeroCtaProps {
  slug: string
  cityName: string
  /** lead grass guide slug */
  grass?: string
  zip?: string
}

export function CityHeroCta({ slug, cityName, grass, zip }: CityHeroCtaProps) {
  const grassIdHref = cityDiagnoseHref(slug)
  const fertilizerHref = cityFertilizerHref({ slug, grass, zip })

  return (
    <div className="alm-hero__cta">
      <Link
        href={grassIdHref}
        prefetch={false}
        className="alm-cta alm-cta--primary"
        onClick={() => trackEvent('city_page_cta_clicked', { city: slug, action: 'grass_id' })}
      >
        <Camera size={18} aria-hidden="true" />
        <span>Identify your {cityName} grass from a photo</span>
      </Link>
      <Link
        href={fertilizerHref}
        prefetch={false}
        className="alm-cta alm-cta--ghost"
        onClick={() => trackEvent('city_page_cta_clicked', { city: slug, action: 'fertilizer_schedule' })}
      >
        <CalendarCheck size={18} aria-hidden="true" />
        <span>Get my {cityName} fertilizer schedule</span>
        <ArrowRight size={16} aria-hidden="true" className="alm-cta__arrow" />
      </Link>
    </div>
  )
}
